import { useEffect, useState } from "react";
import Header from "./header";
import MobileNav from "./mobileNav";
import StoreBar from "./storeBar";
import PushNotificationBanner from "../components/pushNotificationBanner";
import FAB from "../components/fab";
import styles from "../styles/_layouts/layout.module.scss";

// Guided-tour overlays are mounted at the router level (see routes.jsx)
// so they persist across navigations. The `Layout` component instances
// here are torn down on every route change; anything inside them would
// lose its state.

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isBarOpen, setIsBarOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  let topBarStatus = localStorage.getItem("topBarStatus");
  topBarStatus = JSON.parse(topBarStatus);

  useEffect(() => {
    if (!topBarStatus) {
      localStorage.setItem("topBarStatus", JSON.stringify("open"));
      setIsBarOpen(true);
    } else if (topBarStatus) {
      if (topBarStatus !== "open") {
        let dateFromStorage = new Date(topBarStatus);
        let currentDate = new Date();
        if (currentDate > dateFromStorage) {
          localStorage.setItem("topBarStatus", JSON.stringify("open"));
          setIsBarOpen(true);
        }
      }
    }
  }, []);

  const handleClose = () => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 7);
    const dateString = new Date(currentDate);
    localStorage.setItem("topBarStatus", JSON.stringify(dateString));
    setIsBarOpen(false);
  };

  return (
    <div
      className={`${styles.container} ${submenuOpen ? styles.submenuOpen : ""}`}
    >
      <Header setIsOpen={setIsOpen} onSubmenuChange={setSubmenuOpen} />
      <div className={styles.content}>
        <PushNotificationBanner />
        {isBarOpen && <StoreBar handleClose={handleClose} />}
        <main className={styles.main}>{children}</main>
      </div>
      {isOpen && <MobileNav setIsOpen={setIsOpen} />}
      <FAB />
    </div>
  );
};

export default Layout;
